import { Injectable } from '@angular/core';
import { formatDate } from '@angular/common';


@Injectable({
  providedIn: 'root'
})
export class DateFormatterService {

  readonly formats = {
    full: 'EEE, MM/dd/yyyy, hh:mm a',
    long: 'MM/dd/yyyy, hh:mm a',
    time: 'hh:mm a',
    ionPicker: 'yyyy-MM-dd',
    ionPickerDisplay: 'MMMM dd, yyyy',
    simpleDate: 'MM/dd/yyyy',
    short: 'MM/dd hh:mm a',
    date: 'EEE, MM/dd/yyyy'
  };

  fullDate(date: Date) {
    return formatDate(date, this.formats.full, "en-US");
  }

  date(date: Date) {
    return formatDate(date, this.formats.date, "en-US");
  }

  time(date: Date) {
    return formatDate(date, this.formats.time, "en-US");
  }

  short(date: Date) {
    return formatDate(date, this.formats.short, "en-US");
  }

  long(date: Date) {
    return formatDate(date, this.formats.long, "en-US");
  }

  ionPicker(date: Date) {
    return formatDate(date, this.formats.ionPicker, "en-US");
  }

  ionPickerDisplay(date: Date) {
    return formatDate(date, this.formats.ionPickerDisplay, "en-US");
  }

  simpleDate(date: Date) {
    return formatDate(date, this.formats.simpleDate, "en-US");
  }

  fromDateObj(date: { year: number, dayOfMonth: number, monthValue: number, hour: number, minute: number }): Date {
    try {
      return new Date(date.year, date.monthValue - 1, date.dayOfMonth, date.hour, date.minute);
    } catch (ex) {
      return null;
    }
  }

}
